import styled from 'styled-components';
import { ACTION_HEADER_OFFSET, DRAWER_PADDING } from '../../constants';

export const ProfileContainer = styled.div`
  padding: ${DRAWER_PADDING}px ${DRAWER_PADDING}px 0px ${DRAWER_PADDING}px;
  z-index: 11;
  width: 100%;
`;

export const ActionHeader = styled.div`
  position: absolute;
  top: ${ACTION_HEADER_OFFSET}px;
  height: ${ACTION_HEADER_OFFSET}px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 0px ${DRAWER_PADDING}px;
`;

export const Container = styled.div`
  display: flex;
  overflow: auto;
  position: relative;
  height: 100%;
`;

export const EditIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: auto;

  &:hover {
    cursor: pointer;
  }
`;

export const ContentContainer = styled.div`
  flex: 1;
  width: 100%;
`;

export const GoBackIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
`;

export const DropdownMenuContainer = styled.div`
  align-items: center;
  justify-content: center;
  display: flex;
  margin-left: auto;
`;
